import { type AxiosInstance } from "axios";
import type { OrderFormData, Order } from "@/features/dmManagement/types";
import { handleMutationError } from "@/features/dmManagement/api/handleApiError";

/**
 * 新規発注を登録する。
 * @param apiClient - axios インスタンス
 * @param data - 発注フォーム入力データ（タスク情報・デザイン・宛先リスト・差替え原稿）
 * @returns 作成された発注情報
 */
export const PostOrderAPI = async (
  apiClient: AxiosInstance,
  data: OrderFormData
): Promise<Order> => {
  const url = "/dm/orders/";

  // FormDataはJSON→snake_case自動変換(axios-case-converter)の対象外のため、キー名を直接snake_caseで指定する
  const formData = new FormData();
  formData.append("task_id", String(data.taskId));
  formData.append("task_name", data.taskName);
  formData.append("dm_design_id", String(data.dmDesignId));
  formData.append("address_list_file", data.addressListFile);

  if (data.replacementComponents) {
    data.replacementComponents.forEach((component, index) => {
      formData.append(
        `replacement_components[${index}]design_component_id`,
        String(component.designComponentId)
      );
      formData.append(`replacement_components[${index}]file`, component.file);
    });
  }

  try {
    const response = await apiClient.post<Order>(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return handleMutationError(error);
  }
};
